import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

const app = createApp(App);

if (import.meta.env.PROD) {
  void import("@sentry/vue").then(Sentry => {
    Sentry.init({
      app,
      dsn: "https://b73a75dc42f4ab1b3e88fd5d7879fe87@o1418389.ingest.us.sentry.io/4509870089437184",  
      sendDefaultPii: true,
      integrations: [
        Sentry.replayIntegration()
      ],  
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
  });
}

app.mount("#app");
